/**
 * Sets the storage provider prefix
 */

export default angular.module("configuration.storage", ["common"]).config(function (StorageProvider) {
  StorageProvider.setPrefix("epiphany-analytics-app");
}).name;
